import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=fa77e268&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=fa77e268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa77e268",
  null
  
)

export default component.exports